import { Body1 } from '@cian/ui-kit/typography';

import { type FC } from 'react';

import { Link } from '../Link';

import style from './style.css';

interface ISeoMortgageLinkProps {
  url: string;
  title: string;
  testId: string;
  onClick: () => void;
}

export const SeoMortgageLink: FC<ISeoMortgageLinkProps> = ({ url, onClick, title, testId }) => {
  return (
    <div className={style['container']} data-testid={testId}>
      <div className={style['link']}>
        <Body1>
          <Link target="blank" url={url} onClick={onClick}>
            {title}
          </Link>
        </Body1>
      </div>
    </div>
  );
};
